import React, { Component } from 'react';

class Settings extends Component {
  render() {
    console.log('oi');
    return (
      <div>
        <h3 data-testid="settings-title">Settings</h3>
      </div>
    );
  }
}

export default Settings;
